import recurring from './recurringQuestionnaire'
import baseline from './baselineQuestionnaire'

export default {
  recurring,
  baseline
}



// WEBPACK FOOTER //
// ./src/store/questionnaires/index.js